import { ActionTypes, ActionPriceRequest } from './types';

export type TypePriceRequest = () => ActionPriceRequest;

export const priceRequest: TypePriceRequest = () => ({
  type: ActionTypes.PRICE_REQUEST
});
